<template>
  <div :style="{display: status}">
    <div class="v-model"></div>
    <div class="la-line-spin-clockwise-fade">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VLoading',
  data () {
    return {
      status: 'none'
    }
  },
  methods: {
    show: function () {
      this.status = 'block'
    },
    hide: function () {
      this.status = 'none'
    }
  }
}
</script>

<style lang="less" scoped>
.v-model {
  z-index: 199;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  opacity: 0.5;
  background: #000;
}
.la-line-spin-clockwise-fade,
.la-line-spin-clockwise-fade > div {
  z-index: 200;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.la-line-spin-clockwise-fade {
  display: block;
  font-size: 0;
  color: #fff;
}
.la-line-spin-clockwise-fade.la-dark {
  color: #333;
}
.la-line-spin-clockwise-fade > div {
  display: inline-block;
  float: none;
  background-color: currentColor;
  border: 0 solid currentColor;
}
.la-line-spin-clockwise-fade {
  width: 64px;
  height: 64px;
}
.la-line-spin-clockwise-fade > div {
  position: absolute;
  width: 4px;
  height: 4px;
  margin: 2px;
  margin-top: -0.1rem;
  margin-left: -0.02rem;
  border-radius: 50%;
  animation: line-spin-clockwise-fade 1s infinite ease-in-out;
}
.la-line-spin-clockwise-fade > div:nth-child(1) {
  top: 15%;
  left: 50%;
  transform: rotate(0deg);
  animation-delay: -0.875s;
}
.la-line-spin-clockwise-fade > div:nth-child(2) {
  top: 25.2512626585%;
  left: 74.7487373415%;
  transform: rotate(45deg);
  animation-delay: -0.75s;
}
.la-line-spin-clockwise-fade > div:nth-child(3) {
  top: 50%;
  left: 85%;
  transform: rotate(90deg);
  animation-delay: -0.625s;
}
.la-line-spin-clockwise-fade > div:nth-child(4) {
  top: 74.7487373415%;
  left: 74.7487373415%;
  transform: rotate(135deg);
  animation-delay: -0.5s;
}
.la-line-spin-clockwise-fade > div:nth-child(5) {
  top: 84.9999999974%;
  left: 50.0000000004%;
  transform: rotate(180deg);
  animation-delay: -0.375s;
}
.la-line-spin-clockwise-fade > div:nth-child(6) {
  top: 74.7487369862%;
  left: 25.2512627193%;
  transform: rotate(225deg);
  animation-delay: -0.25s;
}
.la-line-spin-clockwise-fade > div:nth-child(7) {
  top: 49.9999806189%;
  left: 15.0000039834%;
  transform: rotate(270deg);
  animation-delay: -0.125s;
}
.la-line-spin-clockwise-fade > div:nth-child(8) {
  top: 25.2506949798%;
  left: 25.2513989292%;
  transform: rotate(315deg);
  animation-delay: 0s;
}
@keyframes line-spin-clockwise-fade {
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/christmasPC-2019/components/Loading.vue